export default __webpack_public_path__ + "static/media/ic_next.887e28b0.svg";